<!-- src/components/InfoPopup.svelte -->
<script>
  import { fade, scale } from "svelte/transition";

  // Props
  export let open = false;
  export let title = "";
  export let description = "";
  export let imageSrc = "";
  export let alt = "Popup image";

  // Callback when closing
  export let onClose;

  function handleOverlayClick(e) {
    if (e.target === e.currentTarget) {
      onClose?.();
    }
  }

  function handleKeydown(e) {
    if (open && e.key === "Escape") {
      onClose?.();
      e.preventDefault();
    }
  }
</script>

<svelte:window on:keydown={handleKeydown} />

{#if open}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    transition:fade={{ duration: 200 }}
    class="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4"
    on:click={handleOverlayClick}
  >
    <div
      transition:scale={{ duration: 180, start: 0.94, opacity: 0 }}
      class="relative bg-white rounded-2xl shadow-2xl max-w-[1200px] w-full mx-2 sm:mx-4 md:mx-8 lg:mx-16 max-h-[90vh] overflow-y-auto"
    >
      <!-- Close button -->
      <button
        class="absolute top-4 right-4 sm:top-5 sm:right-5 z-20 text-gray-600 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-full p-2 transition hover:bg-gray-100"
        on:click={onClose}
        aria-label="Close popup"
        title="Close (Esc)"
      >
        <svg
          class="w-8 h-8"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M18 6L6 18" />
          <path d="M6 6l12 12" />
        </svg>
      </button>

      <div class="p-6 sm:p-8 md:p-10 lg:p-12">
        <div
          class="flex flex-col lg:flex-row gap-6 sm:gap-8 lg:gap-12 items-start lg:items-stretch"
        >
          <!-- Left column: Title + Image -->
          <div
            class="flex flex-col gap-6 lg:gap-8 lg:w-5/12 flex-shrink-0 w-full"
          >
            {#if title}
              <h2
                class="
                  pt-10 sm:pt-12 lg:pt-0
                  text-3xl sm:text-4xl lg:text-5xl
                  font-bold text-gray-900
                  leading-tight
                  max-w-full
                "
              >
                {title}
              </h2>
            {/if}

            {#if imageSrc}
              <div class="lg:order-2 flex justify-center lg:justify-start">
                <div
                  class="w-full max-w-[420px] h-[300px] sm:h-[400px] lg:h-[500px] overflow-hidden rounded-xl shadow-md"
                >
                  <img
                    src={imageSrc}
                    {alt}
                    class="w-full h-full object-cover"
                    width="420"
                    height="500"
                    loading="lazy"
                  />
                </div>
              </div>
            {/if}
          </div>

          <!-- Right column: Description -->
          <div
            class="flex-1 w-full lg:pt-[calc(1.25rem+theme(fontSize.5xl)*1.2)]"
          >
            {#if description}
              <p
                class="text-gray-700 text-base sm:text-lg md:text-xl leading-relaxed whitespace-pre-line"
              >
                {description}
              </p>
            {/if}

            <slot name="extra" />
          </div>
        </div>
      </div>
    </div>
  </div>
{/if}
